export function isAndroidWebView(userAgent?: string) {
  const ua =
    userAgent ??
    (typeof window !== "undefined" ? window.navigator.userAgent : "");
  return /wv/gi.test(ua) || /CatchOfTheDayAndroidApp/gi.test(ua);
}

export function isAndroidHybridApp(userAgent?: string) {
  const ua =
    userAgent ??
    (typeof window !== "undefined" ? window.navigator.userAgent : "");
  return /CatchOfTheDayAndroidApp/gi.test(ua);
}
